module.exports = __webpack_public_path__ + "Deepak-250f34d8.png";